import Layout from "../../../layouts/Layout";
import GenerateDevice from "../../../components/maintenance/GenerateDevice";
import GenerateMultipleDevice from "../../../components/maintenance/GenerateMultipleDevice";
import CleanDevice from "../../../components/maintenance/CleanDevice";
import React, { useState } from "react";
import { ReportsComponentContainer } from "../../../components/reports/ReportsComponent/styles";
import {Tab, Tabs} from "../../../components/base/Tab";

export default function GenerateDevices() {
  const [currentMaintenance, setCurrentMaintenance] = useState();
  const color = "#6e0072"

  return(
        <Layout scrollable>
          <ReportsComponentContainer>
            <Tabs
              id="MaintenancePicker"
              onSelect={setCurrentMaintenance}
              activeKey={currentMaintenance}
            >
              <Tab eventKey="generateDevice" title={"Generate Device"}>
                <GenerateDevice primaryColor={color} />
              </Tab>
              <Tab eventKey="generateMultipleDevice" title={"Generate Multiple Devices"}>
                <GenerateMultipleDevice primaryColor={color}/>
              </Tab>
              <Tab eventKey="cleanDevice" title={"Clear Device"}>
                <CleanDevice primaryColor={color}/>
              </Tab>
            </Tabs>

          </ReportsComponentContainer>
        </Layout>
    )
}